import { useMemo } from 'external/react'
import { styled } from 'external/material';
import { subdomainLink, viewerGuard } from 'utils/url'
import useTranslate from 'hooks/translations'
import useProfile from 'hooks/profile';

const StyledDreyfousLink = styled('a')(dreyfousLinkStyles)

const DreyfousLabsLink = () => {
  const {translate} = useTranslate()
  const {dreyfouslabs} = useProfile()

  const available = useMemo(() => dreyfouslabs && dreyfouslabs.length > 0, [dreyfouslabs])

  if (!available) return null

  return (
    <StyledDreyfousLink {...viewerGuard({href: `${subdomainLink('dreyfouslabs', 'index.html')}?from=edusystem`, target: "_blank"})} >
      {translate('dreyfouslabs_label')}
    </StyledDreyfousLink>
  )
}

function dreyfousLinkStyles() {
  return {
      borderRadius: '5px',
      cursor: 'pointer',
      padding: '6px 15px',
      margin: '5px',
      display: 'flex',
      textDecoration: 'none',
      color: '#565f77',
      fontSize: '13pt',
      backgroundColor: '#fff',
      '&.guide': {
        marginLeft: 15
      },
      '&.inactive': {
        display: 'none',
        pointerEvents: 'none',
        opacity: '0.5'
      },
      '& a': {
        display: 'flex',
        textDecoration: 'none',
        '& label': {
          cursor: 'pointer',
          marginLeft: 10,
          '&:hover': {
            color: '#00f'
          }
        },
        '& svg': {
          width: 20,
          height: 20,
          fill: '#6bb2ff'
        }
    },
  }
}

export default DreyfousLabsLink
